export default __webpack_public_path__ + "static/media/mango_slushie.247145f0.JPG";